module.exports = __webpack_public_path__ + "img/bad.97eafa0d.png";